import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import getMessageCatalog from "data/actions/getMessageCatalog";
import { useCSRFToken } from "components/hooks/useCSRFToken";

import Popover, { usePopover } from "components/ui/Popover";
import WithMessage from "components/WithMessage";
import InfoIcon from "components/ui/InfoIcon";
import ButtonAsLink from "components/ui/ButtonAsLink";
import styled from "styled-components";

export const UCExtensionNotice = ({
  className,
  semester,
  course,
  size = "13",
}) => {
  const dispatch = useDispatch();
  const csrfToken = useCSRFToken();

  useEffect(() => {
    if (csrfToken) {
      dispatch(getMessageCatalog(csrfToken));
    }
  }, [csrfToken, dispatch]);

  const popover = usePopover();

  const { classes: [{ academicCareer: firstCourseAcademicCareer } = {}] = [] } =
    semester || {};
  const { academicCareer: courseAcademicCareer } = course || {};
  const academicCareer = firstCourseAcademicCareer
    ? firstCourseAcademicCareer
    : courseAcademicCareer;

  if (academicCareer === "UCBX") {
    return (
      <UCExtensionNoticeStyles className={className} $size={size}>
        <div className="noticeHeader">
          <UCExtensionSubHeader />{" "}
          <ButtonAsLink onClick={popover.open}>
            <InfoIcon />
          </ButtonAsLink>
        </div>

        <div className="messagePopover">
          {popover.isOpen && (
            <WithMessage set="28000" number="330">
              {(message) => (
                <Popover
                  ref={popover.ref}
                  title={message.text}
                  close={popover.close}
                >
                  <div
                    dangerouslySetInnerHTML={{ __html: message.description }}
                  ></div>
                </Popover>
              )}
            </WithMessage>
          )}
        </div>
      </UCExtensionNoticeStyles>
    );
  }
  return null;
};

UCExtensionNotice.displayName = "UCExtensionNotice";
UCExtensionNotice.propTypes = {
  className: PropTypes.string,
  semester: PropTypes.object,
  course: PropTypes.object,
  size: PropTypes.string,
};

export const UCExtensionNoticeStyles = styled.div`
  .noticeHeader {
    font-size: ${(props) => props.$size + "px" || "13px"};
    font-weight: bold;
  }

  .messagePopover {
    position: relative;
    margin: var(--sm);
  }
`;

export const UCExtensionSubHeader = ({ className }) => {
  return (
    <UCExtensionSubHeaderStyles className={className}>
      UCB Extension Concurrent Enrollment
    </UCExtensionSubHeaderStyles>
  );
};
UCExtensionSubHeader.displayName = "UCExtensionSubHeader";
UCExtensionSubHeader.propTypes = {
  className: PropTypes.string,
};

const UCExtensionSubHeaderStyles = styled.span`
  color: var(--dove-gray);
  font-weight: bold;
`;
